import { FC } from 'react'
import CircleIndicator from '@/ui/components/circle-indicator'
import { ProviderActivationCardProps } from './ProviderActivationCard.types'
import {
    Card,
    IconSlot,
    Content,
    Title,
    Subtitle,
    ArrowButton,
    Arrow,
} from './ProviderActivationCard.styles'

const ProviderActivationCard: FC<ProviderActivationCardProps> = ({
    icon,
    title,
    subtitle,
    onClick,
    isLoading = false,
    disabled,
    compact = false,
    dataTestId,
}) => {
    const isDisabled = disabled ?? isLoading

    return (
        <Card
            onClick={onClick}
            disabled={isDisabled}
            compact={compact}
            data-testid={dataTestId}
        >
            <IconSlot>{icon}</IconSlot>
            <Content hasSubtitle={!!subtitle}>
                <Title variant="m-medium">{title}</Title>
                {subtitle && (
                    <Subtitle variant="s-regular">{subtitle}</Subtitle>
                )}
            </Content>
            {isLoading ? (
                <CircleIndicator loading={true} size={20} width={2} />
            ) : (
                <ArrowButton>
                    <Arrow>→</Arrow>
                </ArrowButton>
            )}
        </Card>
    )
}

export default ProviderActivationCard
